<template>
  <v-card class="pa-2 col-sm-12">
    <v-skeleton-loader
      :loading="firstLoad && loading"
      type="table"
    >
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          cols="12"
          md="3"
        >
          <h3 class="color-services">All Services</h3>
        </v-col>
        <v-col
          no-gutters
          cols="12"
          md="9"
        >
          <v-row
            justify="end"
            align="center"
          >
            <v-col
              cols="12"
              md="3"
            >
              <v-select
                v-model="client_details"
                :items="client_list"
                placeholder="Select Client"
                item-text="name"
                item-value="id"
                return-object
                @change="getServiceTableData"
                class="custom-bottom-line"
                hide-details
                outlined
                dense
              >
              </v-select>
            </v-col>

            <v-col v-if="$store.state.isMobile">
              <v-text-field
                outlined
                v-model="search"
                hide-details
                placeholder="Search"
                prepend-inner-icon="mdi-magnify"
                color="indigo accent-3"
                class="search-field"
              ></v-text-field>
            </v-col>

            <v-text-field
              v-if="!$store.state.isMobile"
              outlined
              v-model="search"
              hide-details
              placeholder="Search"
              prepend-inner-icon="mdi-magnify"
              color="indigo accent-3"
              class="pe-3 search-field"
            ></v-text-field>

            <v-btn
              color="indigo accent-3"
              class="search-btn ms-2"
              dark
              :to="{name:routerPath.adminPanel.children.clientMaster.children.serviceAdd.name}"
            >
              <v-icon left>mdi-plus</v-icon>
              <span>Add Service</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-1"></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="itemsTotal"
        :loading="loading"
        :page.sync="pagination.page"
        hide-default-footer
        @page-count="10"
        :calculate-widths="false"
        @click:row="clicked"
        mobile-breakpoint="0"
        class="clickable-table"
      >

        <template v-slot:[`item.table_id`]="{ item }">
          {{item.id}}
        </template>

        <template v-slot:[`item.client_name`]="{ item }">
          {{client_details.name}}
        </template>

        <template v-slot:[`item.created`]="{ item }">{{
          formatDate(item.created)
        }}</template>

        <template v-slot:[`item.modified`]="{ item }">{{
          formatDate(item.modified)
        }}</template>

        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            text
            color="indigo accent-3"
            style="text-transform: none;"
            small
            :to="{
              name: routerPath.adminPanel.children.clientMaster.children.serviceEdit.name,
              params: { id: item.id },
            }"
          >
            <span>Edit</span>
          </v-btn>
          <v-btn
            text
            color="indigo accent-3"
            style="text-transform: none;"
            small
            @click="deleteService(item.id)"
          >
            <span>Delete</span>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <EmptyState text="Service" />
        </template>

        <!-- <template v-slot:loading class="ma-0 pa-0">
        <v-skeleton-loader
          :loading="loading"
          type="table-tbody"
          class="mx-auto"
        ></v-skeleton-loader>
        </template>-->
      </v-data-table>
      <v-divider class="mt-1 mb-2"></v-divider>
      <!-- <v-skeleton-loader :loading="firstLoad" type="table-tfoot"> -->
      <v-row
        align="center"
        justify-md="end"
        v-if="!$store.state.isMobile"
      >
        <span
          class="body-2 text-color"
          style="margin-end: 73px"
        >
          Showing
          {{
            pagination.itemsPerPage * pagination.page -
              pagination.itemsPerPage +
              1
          }}
          -
          {{
            pagination.itemsPerPage * pagination.page > itemsTotal
              ? itemsTotal
              : pagination.itemsPerPage * pagination.page
          }}
          of {{ itemsTotal }}
        </span>

        <v-btn
          text
          color="indigo accent-3 body-2"
          :disabled="1 == pagination.page"
          @click="pagination.page = pagination.page - 1"
        >
          <span>Previous</span>
        </v-btn>

        <span class="body-2 text-color ms-9 me-9">Page {{ pagination.page }}</span>

        <v-btn
          text
          color="indigo accent-3"
          :disabled="Math.ceil(itemsTotal / 10) == pagination.page"
          @click="pagination.page = pagination.page + 1"
        >
          <span>Next</span>
        </v-btn>
      </v-row>

      <v-row
        v-else
        align="center"
        justify="center"
      >
        <v-row
          class="ma-0 pt-2"
          align="center"
          justify="center"
        >
          <v-btn
            text
            color="indigo accent-3 body-2"
            :disabled="1 == pagination.page"
            @click="pagination.page = pagination.page - 1"
          >
            <span>Previous</span>
          </v-btn>

          <span class="body-2 text-color ms-9 me-9">Page {{ pagination.page }}</span>

          <v-btn
            text
            color="indigo accent-3"
            :disabled="Math.ceil(itemsTotal / 10) == pagination.page"
            @click="pagination.page = pagination.page + 1"
          >
            <span>Next</span>
          </v-btn>
        </v-row>
        <v-col
          cols="12"
          align="center"
        >
          <span class="body-2 text-color">
            Showing
            {{
              pagination.itemsPerPage * pagination.page -
                pagination.itemsPerPage +
                1
            }}
            -
            {{
              pagination.itemsPerPage * pagination.page > itemsTotal
                ? itemsTotal
                : pagination.itemsPerPage * pagination.page
            }}
            of {{ itemsTotal }}
          </span>
        </v-col>
      </v-row>
    </v-skeleton-loader>
    <v-dialog
      v-model="deletePrompt"
      max-width="450"
    >
      <v-card>
        <v-card-title>
          <span class="modal-heading">Are you sure?</span>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo accent-3"
            text
            @click="deletePrompt = false"
            class="search-btn"
          >
            <v-icon
              size="16"
              left
            >mdi-close</v-icon>
            <span>Close</span>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <span class="custom-lable-field">Do you want to delete the record ?</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="flat accent-3"
            dark
            style="width:100px"
            class="mb-4 me-2"
            @click="deletePrompt=false"
          >No</v-btn>
          <v-btn
            color="indigo accent-3"
            dark
            style="width:100px"
            class="mb-4 me-2"
            @click="deleteServiceService()"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  <!-- </v-layout> -->
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTER_URL, API_ADMIN_URL } from "../../../../constants/urls";

import Keys from "../../../../constants/keys";
import PermissionKeys from "../../../../constants/PermissionKeys";
import Axios from "../../../../api/BaseAxios";
import EmptyState from "../../../../components/EmptyState/EmptyState";
import store from "../../../../store"

import Helper from "../../../../helper";

export default {
  name: "ServiceList",
  components: {
    EmptyState,
  },
  data () {
    return {
      PermissionKeys: PermissionKeys,
      routerPath: ROUTER_URL,
      items: [],
      search: "",
      itemsTotal: 0,
      loading: true,
      firstLoad: true,
      isMobile: false,
      client_list: [],
      defaultClient: {
        id: -1,
        name: "Default"
      },
      deletePrompt: false,
      serviceId: 0,
      pagination: { sortBy: ["name"], sortDesc: [false] },
      headers: [
        {
          text: "ID",
          value: "table_id",
          class: "black--text font-weight-bold ",
          width: "1%",
        },
        {
          text: "Name",
          value: "service_name",
          class: "black--text font-weight-bold ",
          width: "1%",
        },
        {
          text: "Client Name",
          value: "client_name",
          sortable: false,
          class: "black--text font-weight-bold",
          width: "1%",
        },
        {
          text: "Created",
          value: "created",
          sortable: false,
          class: "black--text font-weight-bold",
          align: "center",
          width: "1%",
        },
        {
          text: "Modified",
          value: "modified",
          sortable: false,
          class: "black--text font-weight-bold",
          align: "center",
          width: "1%",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          class: "black--text font-weight-bold",
          align: "center",
          width: "1%",
        },
      ],
      rowsPerPageItems: [5, 10, 20, 50, 100],
    };
  },
  created () {
    this.PermissionKeys = PermissionKeys;
  },
  computed: {
    ...mapGetters({
      permissions: "mainStore/getPermissions",
    }),
    client_details: {
      get () {
        return this.$store.state.masters.clientDetails;
      },
      set (value) {
        store.dispatch("masters/updateClientDetailsMastersModule", value);
      }
    }
  },
  watch: {
    pagination () {
      console.log(this.pagination);
      if (!this.firstLoad) this.getServiceTableData();
      this.firstLoad = false;
    },
    search () {
      this.pagination.page = 1;
      this.getServiceTableData();
    },
    permissions () {
      if (this.permissions.indexOf(this.PermissionKeys.MASTERS_SERVICE_DETAILS) < 0) {
        this.$router.push({ name: "eblityLogin" });
      }
    },
  },
  methods: {
    formatClientName (client_details) {
      return (client_details != null ? client_details.name : 'Default');
    },
    clicked () {
      // this.$router.push({
      //   name: this.routerPath.adminPanel.children.clientMaster.children.serviceDetails.name,
      //   params: { id: value.id },
      // });
    },
    deleteService (id) {
      this.serviceId = id
      this.deletePrompt = true;
    },
    deleteServiceService () {

      const successHandler = res => {
        console.log(res);
        this.deletePrompt = false
        this.getServiceTableData()
      };

      const failureHandler = res => {
        console.log(res);
        this.$forceUpdate();
        this.deletePrompt = false
      };

      let requestParams = {}
      requestParams[Keys.ID] = this.serviceId;
      if(this.client_details){
      requestParams[Keys.CLIENT] = this.client_details.id;
      }
      else{
      requestParams[Keys.CLIENT] = -1;
      }
      Axios.request_DELETE(
        API_ADMIN_URL.serviceDelete,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
    formatDate (date) {
      return Helper.formatDate(date);
    },
    getServiceTableData () {
      const self = this;
      this.loading = true;

      console.log(this.pagination);

      const successHandler = (res) => {
        this.loading = false;
        // this.firstLoad = false;
        this.items = res.data.data;
        this.itemsTotal = res.data.recordsTotal;
        if (!Helper.isEmptyObject(self.client_details)) {
          self.$store.state.selected_client = self.client_details;
        }
      };

      const failureHandler = (res) => {
        console.log(res);
        this.loading = false;
        // this.firstLoad = false;
      };

      let dataTableParams = {};
      dataTableParams['client'] = this.client_details.id;
      dataTableParams[Keys.LENGTH] = this.pagination.itemsPerPage
        ? this.pagination.itemsPerPage
        : 10;
      dataTableParams[Keys.PAGE] = this.pagination.page;
      dataTableParams[Keys.SEARCH] = this.search;
      dataTableParams['client'] = this.client_details.id;
      try {
        for (let a = 0; a < this.headers.length; a++) {
          if (
            this.pagination.sortBy.length > 0 &&
            this.pagination.sortBy[0] == this.headers[a].value
          ) {
            dataTableParams[Keys.SORTING_COLUMN] = a;
            dataTableParams[Keys.FLAG_DESCENDING] = this.pagination.sortDesc[0];
          }
        }
      } catch (error) {
        // console.log(error);
      }

      return Axios.request_POST(
        API_ADMIN_URL.serviceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler
      );
    },
    getClientList () {
      var self = this;

      self.formLoading = true;

      const successHandler = res => {
        self.formLoading = false;
        self.client_list = res.data.data;
        self.client_list.push(self.defaultClient);
      };

      const failureHandler = {};

      let requestParams = {};

      Axios.request_POST(
        API_ADMIN_URL.clientList,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
  },
  mounted () {
    if (!this.client_details) {
      this.client_details = this.defaultClient
    }
    this.getClientList();
    this.getServiceTableData();
    if (this.$store.state.selected_client != null) {
      this.client_details = this.$store.state.selected_client;
    }
  },
};
</script>

<style scoped>
.wrap-text {
  max-height: 21px;
  max-width: 191px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
